import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const ToastManager = {
  showLoading: (message = 'Processing...') => {
    // Displays a loading toast and returns a unique toastId
    return toast.loading(message, {
      position: "bottom-right",
      autoClose: false,
      hideProgressBar: true,
      draggable: false,
      theme: "light",
      pauseOnHover: true,
      closeButton: true
    });
  },

  showSuccess: (toastId, message = 'Success!') => {
    // Updates the toast to show a success message
    toast.update(toastId, {
      render: message,
      type: 'success',
      isLoading: false,
      autoClose: 5000, // Automatically close after 5 seconds
      hideProgressBar: false,
      draggable: false,
      pauseOnHover: true,
      closeButton: true
    });
  },

  showError: (toastId, message = 'An error occurred!') => {
    // Updates the toast to show an error message
    toast.update(toastId, {
      render: message,
      type: 'error',
      isLoading: false,
      autoClose: 5000, // Automatically close after 5 seconds
      hideProgressBar: false,
      draggable: false,
      pauseOnHover: true,
      closeButton: true,
    });
  },
};

export default ToastManager;
